export const DEFAULT_MAX_UPLOAD_BYTES = 30 * 1024 * 1024;

let configuredMaxUploadBytes = DEFAULT_MAX_UPLOAD_BYTES;

export function setMaxUploadBytes(bytes: number) {
    if (bytes > 0) {
        configuredMaxUploadBytes = bytes;
    }
}

export function getMaxUploadBytes() {
    return configuredMaxUploadBytes;
}

export function getFileTooLargeMessage(maxBytes: number = configuredMaxUploadBytes) {
    const mb = Math.max(1, Math.ceil(maxBytes / (1024 * 1024)));
    return `上传文件过大（最大允许 ${mb} MB）`;
}

export function isFileTooLarge(file: File, maxBytes: number = configuredMaxUploadBytes) {
    return !!file && file.size > maxBytes;
}
